import { Geometry, Point } from "../../drawing";
import { AbstractItem } from "./AbstractItem";
import { IDrawableItem } from "./IDrawableItem";
import { PrintBehavior } from "./PrintBehavior";

export abstract class AbstractDrawableItem extends AbstractItem implements IDrawableItem {
  constructor(typeKey: string) {
    super(typeKey);
  }

  public geometry: Geometry = new Geometry();
  public isVisible: boolean = true;
  public printBehavior: PrintBehavior = new PrintBehavior();
  public isRelayoutableByHeight: boolean = false;
  public isPositionFixed: boolean = false;

  protected applyMembers(clone: AbstractDrawableItem): void {
    super.applyMembers(clone);
    clone.geometry = this.cloneValue(this.geometry);
    clone.isVisible = this.cloneValue(this.isVisible);
    clone.printBehavior = this.cloneValue(this.printBehavior);
    clone.isRelayoutableByHeight = this.cloneValue(this.isRelayoutableByHeight);
    clone.isPositionFixed = this.cloneValue(this.isPositionFixed);
  }

  move(difference: Point): void {
    if (this.isPositionFixed) { return; }
    this.geometry.rectangle = this.geometry.rectangle.move(difference);
  }
}
